import React from 'react';
import { ExternalLink, ArrowRightLeft } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

export const MovedToInductIQ = ({ module }) => (
  <div className="max-w-2xl mx-auto py-16 px-4" data-testid="moved-to-inductiq">
    <Card>
      <CardContent className="p-8 space-y-4">
        <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center">
          <ArrowRightLeft className="w-6 h-6 text-blue-700" />
        </div>
        <h1 className="text-2xl font-semibold text-slate-900" data-testid="moved-to-inductiq-title">{module} moved to InductIQ</h1>
        <p className="text-slate-600">
          Incident reports, OSHA logs and training records now live in InductIQ, so each record is kept in one place.
          Records saved here before the move are kept and not deleted.
        </p>
        <a href="https://inductiq.ai" target="_blank" rel="noopener noreferrer">
          <Button className="mt-2" data-testid="open-inductiq-btn">
            Open InductIQ <ExternalLink className="w-4 h-4 ml-2" />
          </Button>
        </a>
      </CardContent>
    </Card>
  </div>
);

export default MovedToInductIQ;
